// Routes the visit pages live at, named once so the menu filter and the routing table cannot drift
// apart — the same reason MAINTENANCE_ROUTE and APP_MANAGEMENT_ROUTE exist.

/** Raises a new visit. Needs a selected site, so the menu hides it until one is chosen. */
export const ADD_VISIT_ROUTE = '/visits/add';

/** The live onsite list for one site. Needs a selected site, for the same reason as Add Visit. */
export const ONSITE_VEHICLES_ROUTE = '/onsite-vehicles';

/** The visit detail page. The visit id is the path segment; the site rides in `?siteId=`. */
export const visitDetailRoute = (visitId: string, siteId: number) => `/visits/${visitId}?siteId=${siteId}`;
